import { CompanySettingsInterface } from '@focus.cloud/src/interface/BluBookingInterfaces/CompanySettings';

export const defaultCompanySettings: CompanySettingsInterface = {
  companyColorEnum: 0,
  visibilityEnum: 0,
  isManualAppointmentBlock: false,
  isSingleCalendarManagement: false,
  appointmentReminderMinutes: 5,
  isAppointmentReminderActive: true,
};
